import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
import { isRelogin } from '@/utils/request';
import useUserStore from '@/store/modules/user';
// import useSettingsStore from '@/store/modules/settings';
// import usePermissionStore from '@/store/modules/permission';

NProgress.configure({ showSpinner: false });

const whiteList = [
  '/login',
  '/register',
  '/index',
  '/loginByLinkUUID',
  '/h5/news/fill',
];

router.beforeEach((to, _from, next) => {
  NProgress.start();
  if (whiteList.includes(to.path)) {
    // 白名单页面直接放行（如 H5 填报页自行从 url 参数获取 token）
    next();
    return;
  }
  if (getToken() && !useUserStore().userId) {
    // 判断当前用户是否已拉取完user_info信息
    useUserStore()
      .getInfo()
      .then(() => {
        isRelogin.show = false;
        next({ ...to, replace: true });
        // usePermissionStore()
        //   .generateRoutes()
        //   .then(() => {
        //     next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
        //   });
      })
      .catch((err) => {
        console.log(err);
        useUserStore()
          .logOut()
          .then(() => {
            next({ path: '/' });
          });
      });
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done();
});
